module.exports = __webpack_public_path__ + "img/deng.3f51444f.png";